import React, { useState } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";

import Analytics from "../../../../../../helpers/analytics";
import { Mixpanel } from "../../../../../../components/shared/Mixpanel";

import ProductSelector from "./ProductSelector";
import ShopifyWrapper from "../styles/Shopify.style";

function Details(props) {
  const [submitting, setSubmitting] = useState(false);

  const { addToCart, auth, location, shopify, video, user } = props;

  const addToCartButton = (user, video, action) => {
    return () => {
      user.itemSubmitting = true;
      setSubmitting(true);
      const selectedProduct = document.querySelector(
        "input[name=shopify-choices]:checked"
      );

      Analytics.track("AddedToCart", {
        category: "LP-VideoDetail",
        label: video.jmId,
      });
      Mixpanel.track("Video added to cart", {
        JVID: video.jmId,
        "Video Title": video.publishingTitle,
        "Product Type": selectedProduct.getAttribute("data-product-type"),
        "Product Name": selectedProduct.getAttribute("data-product-name"),
        Price: selectedProduct.getAttribute("data-price"),
      });
      const productPrice = parseFloat(selectedProduct.getAttribute("data-price"));

      const productDetails = {
        item_id: video.jmId,
        item_name: video.publishingTitle,
        item_variant: selectedProduct.value,
        item_category: selectedProduct.getAttribute("data-product-type"),
        price: productPrice,
        quantity: 1
      };

      Analytics.track("add_to_cart", {
        ecommerce: {
          currency: "USD",
          value: productPrice,
          items: [productDetails]
        }
      });
      const element = document.querySelector(".cartButton");
      element.classList.add("is-added");
      checkSelectedOption(selectedProduct.value);
      setTimeout(() => {
        action(
          video.jmId,
          video.publishingTitle,
          video.imgUrl,
          selectedProduct.value,
          selectedProduct.getAttribute("data-price"),
          selectedProduct.getAttribute("data-product-name"),
          selectedProduct.getAttribute("data-product-type")
        );
        element.classList.remove("is-added");
      }, 800);
    };
  };

  const checkSelectedOption = (selectedOption) => {
    if (selectedOption === "cartInquiry") {
      user.shopifyReady = false;
    } else {
      user.shopifyReady = true;
    }
  };

  const openDigitalTermModal = () => {
    props.toggleDigitalTermsModal(true);
  };

  return (
    <ShopifyWrapper className="license-option">
      <div className="videoDetailDescription">
        {process.env.REACT_APP_SHOPIFY_SHUTDOWN === "true" ? (
          <p className="shopify-error">
            Whoops! Our easy checkout is temporarily unavailable. If you’re
            interested in licensing a video, please click contact us below. Fill
            out the form, and one of our friendly licensing professionals will
            contact you shortly.
          </p>
        ) : (
          <div className="shopify__product--wrapper">
            {shopify.products.length === 0 && !shopify.errors ? (
              <CircularProgress />
            ) : shopify.errors ? (
              <p className="shopify-error">
                This video can not be added to the cart right now.
                <br />
                Please try again later!
              </p>
            ) : (
              <ProductSelector
                products={shopify.products}
                cartContents={user.cartItems || []}
                video={video}
                submitting={user.itemSubmitting}
                submittingState={submitting}
                openDigitalTermModal={openDigitalTermModal}
                addToCart={addToCartButton(user, video, addToCart)}
                location={location}
                auth={auth}
              />
            )}
          </div>
        )}
      </div>
    </ShopifyWrapper>
  );
}

Details.propTypes = {
  auth: PropTypes.shape().isRequired,
  video: PropTypes.shape().isRequired,
  user: PropTypes.shape().isRequired,
};

export default Details;
